export default __webpack_public_path__ + "static/media/available.10d2f0bc.svg";